/* global posthog */

class PostHogAdapter {
  /**
   * Track an event in PostHog
   * @param {String} eventName - Name of the event to track
   * @param {Object} properties - Event properties/data to track
   * @param {Object} options - Optional tracking options
   */
  static track(eventName, properties = {}, options = {}) {
    if (typeof posthog !== 'undefined' && posthog.capture) {
      posthog.capture(eventName, properties, options);
    }
  }

  /**
   * Identify a user in PostHog
   * @param {Object} userProperties - User properties object containing user_id and other user data
   * @param {Object} companyProperties - Company properties object containing company_id and other company data
   */
  static identify(userProperties, companyProperties = {}) {
    if (typeof posthog !== 'undefined' && posthog.identify && userProperties.uid) {
      // Identify the user
      posthog.identify(userProperties.uid, userProperties);

      // Associate the user with a company if company properties are provided
      if (companyProperties && companyProperties.cid) {
        const { cid, ...restCompanyProperties } = companyProperties;
        if (posthog.group) {
          posthog.group('company', cid, restCompanyProperties);
        }
      }
    }
  }

  /**
   * Alias a user (link multiple distinct IDs to the same user)
   * @param {String} distinctId - The current distinct ID
   * @param {String} alias - The alias to link to
   */
  static alias(distinctId, alias) {
    if (typeof posthog !== 'undefined' && posthog.alias) {
      posthog.alias(alias, distinctId);
    }
  }

  /**
   * Disable PostHog analytics
   */
  static disable() {
    if (typeof posthog !== 'undefined' && posthog.opt_out_capturing) {
      posthog.opt_out_capturing();
    }
  }

  /**
   * Enable PostHog analytics
   */
  static enable() {
    if (typeof posthog !== 'undefined' && posthog.opt_in_capturing) {
      posthog.opt_in_capturing();
    }
  }
}

export default PostHogAdapter;
